var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HomeSection'),_c('OurServiceSection'),_c('FeatureSection'),_c('VideoSection'),_c('MyGallery'),_c('Brand2'),_c('BuyOrSell'),_c('NewsSection',{attrs:{"newsData":_vm.realEstateNews}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }